/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Configuration for access token in header. Must be provided if type is in-header.
 * @export
 * @interface AccessTokenOptsHeader
 */
export interface AccessTokenOptsHeader {
    /**
     * The name of the header to be used for the access token.
     * @type {string}
     * @memberof AccessTokenOptsHeader
     */
    name: string;
    /**
     * The prefix to be added to the access token value when it is sent in the header.
     * @type {string}
     * @memberof AccessTokenOptsHeader
     */
    valuePrefix?: string;
}

/**
 * Check if a given object implements the AccessTokenOptsHeader interface.
 */
export function instanceOfAccessTokenOptsHeader(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AccessTokenOptsHeaderFromJSON(json: any): AccessTokenOptsHeader {
    return AccessTokenOptsHeaderFromJSONTyped(json, false);
}

export function AccessTokenOptsHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenOptsHeader {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'valuePrefix': !exists(json, 'valuePrefix') ? undefined : json['valuePrefix'],
    };
}

export function AccessTokenOptsHeaderToJSON(value?: AccessTokenOptsHeader | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'valuePrefix': value.valuePrefix,
    };
}

